export enum QueryParameterKey {
  Category = 'category',
  Subcategory = 'plan',
  SelectedPlanId = 'planId',
  SelectedPlanQuantity = 'quantity',
}
